import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import b from "../util/net.js";
import e from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import s from "../common/event-logger.js";
import { newInAppMessageFromJson as it } from "./in-app-message-factory.js";
import { randomInclusive as lt } from "../util/math.js";
import t from "../models/request-result.js";
import r from "../../shared-lib/braze-shared-lib.js";
import u from "../managers/subscription-manager.js";
import ut from "../triggers/models/trigger.js";
import { validateValueIsFromEnum as F } from "../util/code-utils.js";
import { BRAZE_ACTION_URI_REGEX as O } from "../util/validation-utils.js";
import { containsPushPrimerBrazeAction as pt, containsUnknownBrazeAction as mt, getDecodedBrazeAction as J, ineligibleBrazeActionURLErrorMessage as gt, INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as ct } from "../util/braze-actions.js";
import ht from "../Push/utils/push-utils.js";

var ge = /*#__PURE__*/function () {
  function ge(t, s, i, r) {
    _classCallCheck(this, ge);

    this.vt = t, this.j = s, this.h = i, this.v = r, this.De = new u(), e.jt(this.De), this._e = 1e3, this.Se = 6e4;
  }

  _createClass(ge, [{
    key: "Be",
    value: function Be() {
      return this.De;
    }
  }, {
    key: "Ee",
    value: function Ee(t) {
      return this.De.ut(t);
    }
  }, {
    key: "Fe",
    value: function Fe() {
      return this.Ge;
    }
  }, {
    key: "Ne",
    value: function Ne(t) {
      this.Ge = t;
    }
  }, {
    key: "qe",
    value: function qe(e, i) {
      if (!F(InAppMessage.Oe, i, "".concat(i, " is not a valid in-app message display failure"), "InAppMessage.DisplayFailures")) return new t();
      var n = {
        trigger_ids: [e],
        error_code: i
      };
      return s.G(r.A.Pe, n);
    }
  }, {
    key: "G",
    value: function G(e, i, n, o) {
      var a = new t();
      var l;
      if (e instanceof ControlMessage) l = {
        trigger_ids: [e.triggerId]
      };else {
        if (i === r.A.Re || e instanceof HtmlMessage && i === r.A.He) {
          if (!e.k(o)) return r.D.info("This in-app message has already received a click. Ignoring analytics event."), a;
        } else if (i === r.A.Je) {
          if (!e.R()) return r.D.info("This in-app message has already received an impression. Ignoring analytics event."), a;
        }

        l = this.Ke(e);
      }
      return null == l ? a : (null != n && (l.bid = n), s.G(i, l));
    }
  }, {
    key: "Qe",
    value: function Qe(e, i) {
      var n = new t();
      if (!e.k()) return r.D.info("This in-app message button has already received a click. Ignoring analytics event."), n;
      var o = this.Ke(i);
      return null == o ? n : e.id === InAppMessageButton.Ue ? (r.D.info("This in-app message button does not have a tracking id. Not logging event to Braze servers."), n) : (null != e.id && (o.bid = e.id), s.G(r.A.He, o));
    }
  }, {
    key: "Ve",
    value: function Ve(t) {
      if (!(t instanceof InAppMessage)) return;

      var s = function s(t) {
        var s = J(t);
        return mt(s) ? gt(ct.We, "In-App Message") : pt(s) && !ht.Xe() ? gt(ct.Ye, "In-App Message") : void 0;
      },
          e = t.buttons;

      var i;

      var _iterator = _createForOfIteratorHelper(e),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          if (_t.clickAction === InAppMessage.ClickAction.URI && O.test(_t.uri) && (i = s(_t.uri), i)) return i;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return t.clickAction === InAppMessage.ClickAction.URI && O.test(t.uri) ? s(t.uri) : void 0;
    }
  }, {
    key: "Ze",
    value: function Ze(t, s, e, i) {
      var _this = this;

      var n = this.vt.ni(!1, !1);
      n = this.vt.Ps(n), n.template = {
        trigger_id: t.triggerId,
        trigger_event_type: s
      }, null != e && (n.template.data = e.li());
      var o = this.vt.Bs(n);
      this.vt.Gs(n, function () {
        b.Hs({
          url: "".concat(_this.vt.Ks(), "/template/"),
          data: n,
          headers: o,
          S: function () {
            var _S = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(s) {
              var e, i, a;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (_this.vt.Os(n, s, o)) {
                        _context.next = 2;
                        break;
                      }

                      return _context.abrupt("return", (_this.qe(t.triggerId, InAppMessage.Oe.ui), void ("function" == typeof t.pi && t.pi())));

                    case 2:
                      if (!(_this.vt.Qs(), null == s || null == s.templated_message)) {
                        _context.next = 4;
                        break;
                      }

                      return _context.abrupt("return", void _this.qe(t.triggerId, InAppMessage.Oe.ui));

                    case 4:
                      e = s.templated_message;

                      if (!(e.type !== ut.gi.mi)) {
                        _context.next = 7;
                        break;
                      }

                      return _context.abrupt("return", void _this.qe(t.triggerId, InAppMessage.Oe.ci));

                    case 7:
                      i = it(e.data);

                      if (!(null == i)) {
                        _context.next = 10;
                        break;
                      }

                      return _context.abrupt("return", void _this.qe(t.triggerId, InAppMessage.Oe.ci));

                    case 10:
                      a = _this.Ve(i);

                      if (!a) {
                        _context.next = 13;
                        break;
                      }

                      return _context.abrupt("return", (r.D.error(a), void ("function" == typeof t.pi && t.pi())));

                    case 13:
                      "function" == typeof t.fi ? t.fi(i) : _this.qe(t.triggerId, InAppMessage.Oe.ui);

                    case 14:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function S(_x) {
              return _S.apply(this, arguments);
            }

            return S;
          }(),
          error: function error(r) {
            var n = "getting user personalization for message ".concat(t.triggerId);
            if (new Date().valueOf() - t.di > t.vi) _this.qe(t.triggerId, InAppMessage.Oe.ui);else {
              var _r = Math.min(t.vi, _this.Se),
                  _o = _this._e;

              null == i && (i = _o);
              var a = Math.min(_r, lt(_o, 3 * i));
              n += ". Retrying in ".concat(a, " ms"), setTimeout(function () {
                _this.Ze(t, s, e, a);
              }, a);
            }

            _this.vt.Vs(r, n);
          }
        });
      });
    }
  }, {
    key: "Ke",
    value: function Ke(t) {
      if (null == t.triggerId) return r.D.info("The in-app message has no analytics id. Not logging event to Braze servers."), null;
      var s = {};
      return null != t.triggerId && (s.trigger_ids = [t.triggerId]), s;
    }
  }]);

  return ge;
}();

export { ge as default };